import { useSelector } from 'react-redux';
import { landingsSelectors } from '../store/modules/landings';
import routes from '../routes';

const { Router } = routes;

const useIsWebinar = () => {
  const isWebinarDashboard = Router.asPath.includes('webinar');
  const isStreamToWebinar = useSelector(landingsSelectors.selectIsWebinar);

  return isWebinarDashboard && isStreamToWebinar;
};

export default useIsWebinar;
